import * as types from 'modules/questionModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string} */
const initialState = null;

const reset = () => null;

/**
 *
 * @param {string} _
 * @param {import('modules/statistics/types').FetchInterventionStatusStatsFailureAction} action
 * @returns {string}
 */
const setError = (_, { payload }) => payload;

export default createReducer(initialState, {
  [types.SET_QUESTION_MODEL_STATISTICS_ID]: reset,
  [types.QUESTION_MODEL_STATISTICS_COUNT_FAILURE]: setError,
  [types.CLEAR_QUESTION_MODEL_STATISTIC]: reset,
});
